import HttpRequest from '@/utils/request'
const axios = new HttpRequest()
export default axios
